
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[categorySlug]",
      function () {
        return require("private-next-pages/news/[categorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[categorySlug]"])
      });
    }
  